import { whenDev } from "@craco/craco";
import { SyntheticEvent, useCallback, useLayoutEffect } from "react";
import { PackEditorCallbacks } from "../core/EditorTypes";
import { fileProcessor, OnFileEventFn, OnFileFn } from "../FileProcessor";

type DropZoneProps = {
  onFile: OnFileFn;
  onFileEvent: OnFileEventFn;
  attach?: boolean;
  other?: {
    onChooseDeck: (decks: string[]) => Promise<string>;
    onChooseColumns: (columns: string[]) => Promise<number[]>;
  };
};

function init(onFile: OnFileFn, onFileEvent: OnFileEventFn, other?: {
  onChooseDeck: (decks: string[]) => Promise<string>;
  onChooseColumns: (columns: string[]) => Promise<number[]>;
}) {
  const dropZone = document.querySelector("#dropzone-window-container")!;
  const fileSelector = document.querySelector(
    "#dropzone-window-container input[type=file]",
  )!;

  const idleText = document.querySelector("#dropzone-window .a")!;
  const hoverText = document.querySelector("#dropzone-window .b")!;

  dropZone.addEventListener("dragover", (event: Event) => {
    event.stopPropagation();
    event.preventDefault();
    // Style the drag-and-drop as a "copy file" operation.
    // @ts-ignore
    event.dataTransfer.dropEffect = "copy";
    dropZone.classList.add("hover");
    hoverText.classList.remove("hidden");
    idleText.classList.add("hidden");
  });

  dropZone.addEventListener("dragleave", (event) => {
    dropZone.classList.remove("hover");
    hoverText.classList.add("hidden");
    idleText.classList.remove("hidden");
  });

  window.ondragover = (event) => {
    event.stopPropagation();
    event.preventDefault();
    event.dataTransfer.dropEffect = "copy";
    dropZone.classList.add("hover");
    hoverText.classList.remove("hidden");
    idleText.classList.add("hidden");
    return false;
  };

  window.ondragleave = (event) => {
    dropZone.classList.remove("hover");
    hoverText.classList.add("hidden");
    idleText.classList.remove("hidden");
    return false;
  };

  window.ondrop = (event) => {
    event.stopPropagation();
    event.preventDefault();
    dropZone.classList.remove("hover");
    hoverText.classList.add("hidden");
    idleText.classList.remove("hidden");

    processFileSelectEvent(event);
    return false;
  };

  const onFileWrapper = (...params: any[]) => {
    dropZone.classList.remove("hover");
    hoverText.classList.add("hidden");
    idleText.classList.remove("hidden");
    // console.log('wrapper', params);
    // @ts-ignore
    onFile(...params);
  };

  const processFileSelectEvent = fileProcessor(
    onFileWrapper,
    onFileEvent,
    other,
  );

  dropZone.addEventListener("drop", processFileSelectEvent);
  fileSelector.addEventListener("change", processFileSelectEvent);
}

const removeAllListeners = () => {
  const dropZone = document.querySelector("#dropzone-window-container")!;
  const fileSelector = document.querySelector(
    "#dropzone-window-container input[type=file]",
  )!;
  dropZone.removeEventListener("drop", removeAllListeners);
  fileSelector.removeEventListener("change", removeAllListeners);

  window.ondragover = null;
  window.ondragleave = null;
  window.ondrop = null;
};

export default function DropZoneWindow(props: DropZoneProps) {
  useLayoutEffect(() => {
    init(props.onFile, props.onFileEvent, props.other);
    return removeAllListeners;
  }, [props]);

  return (
    <div
      id="dropzone-window-container"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1000,
      }}
    >
      <div className="dropzone" id="dropzone-window">
        <p className="a">
          🤲 {props.attach ? "attach files" : "drop file here"}
          <span className="sub">
            {props.attach
              ? "(images, sounds, videos)"
              : "(existing pack: .json, .zip, .csv, .apkg)"}
          </span>
        </p>
        <p
          className="b hidden"
          style={{
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
          }}
        >
          <p style={{ lineHeight: "0.2em" }}>✨ let go</p>
          <p style={{ fontSize: "0.6em", lineHeight: "0.2em" }}>of the file</p>
        </p>
        <input
          type="file"
          id="dropzone-window-file-selector"
          style={{ display: "none" }}
        />
      </div>
    </div>
  );
}

// export const FileSelector = (props: DropZoneProps) => {
//   const { onFile, onFileEvent, other } = props;
//   const onChangeCallback = useCallback(() => {
//     fileProcessor(
//       onFile,
//       onFileEvent,
//       other,
//     );
//   }, [onFile, onFileEvent, other]);
//   return <input type="file" id="dropzone-window file-selector" onChange={onChangeCallback} />;
// };
//
